export default "__VITE_ASSET__02959008__"